export const GA4_MEASUREMENT_ID = 'G-TR0V0WZ9V8';

export const ga4EventNames = Object.freeze({
  'onboarding started': 'onboarding_started',
  gender_selected: 'gender_selected',
  '2nd screen': 'second_screen',
  age_selected: 'age_selected',
  'screen completed': 'screen_completed',
  registration: 'registration',
  paywall: 'paywall',
  'checkout view': 'checkout_view',
  paypal_button_clicked: 'paypal_button_clicked',
  apple_pay_ui_opened: 'apple_pay_ui_opened',
  purchase: 'purchase',
  'App registration': 'app_registration',
  purchaseAditional: 'purchase_additional',
  'app download click': 'app_download_click',
  'purchase server': 'purchase_server',
  'subscription renewal purchase': 'subscription_renewal_purchase',
  additional_purchase: 'additional_purchase',
  'purchase failed': 'purchase_failed',
  'subscription canceled': 'subscription_canceled',
  'Purchase Started': 'purchase_started',
  'Purchase Decline': 'purchase_decline',
  'Purchase Complete': 'purchase_complete',
  'Upsale Purchase Started': 'upsale_purchase_started',
  'Upsale Purchase Decline': 'upsale_purchase_decline',
  'Upsale Purchase Complete': 'upsale_purchase_complete',
});

const propertyNames = Object.freeze({
  'screen id': 'screen_id',
  productId: 'product_id',
  userId: 'user_id',
  'User ID': 'user_id',
  upsaleType: 'upsale_type',
});

const numericProperties = new Set(['price', 'quantity', 'value']);

const normalizeValue = (key, value) => {
  if (value instanceof Error) return value.message.slice(0, 100);
  if (numericProperties.has(key)) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : undefined;
  }
  if (typeof value === 'string') return value.slice(0, 100);
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  return value == null ? undefined : JSON.stringify(value).slice(0, 100);
};

export const normalizeGa4Properties = (properties = {}) => Object.entries(properties)
  .reduce((normalized, [sourceKey, sourceValue]) => {
    if (sourceKey.toLowerCase() === 'email') return normalized;
    const key = propertyNames[sourceKey] || sourceKey;
    const value = normalizeValue(key, sourceValue);
    if (value !== undefined) normalized[key] = value;
    return normalized;
  }, {});

export const trackGoogleAnalyticsEvent = (eventName, properties = {}) => {
  const ga4EventName = ga4EventNames[eventName];
  if (!ga4EventName || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return false;
  }

  try {
    window.gtag('event', ga4EventName, {
      ...normalizeGa4Properties(properties),
      send_to: GA4_MEASUREMENT_ID,
    });
    return true;
  } catch {
    return false;
  }
};
